import { BoxProps } from '@leagueplatform/genesis-commons';
import {
  APP_MANAGED_ROUTES,
  AUTHED_WEBVIEW_URL_NAMES,
  getAuthedWebviewUrl,
  injectCobrowseInitiator,
  LinkHandler,
  UserDropdownProps,
  useGetScreenForAnalytics,
  NAV_ANALYTICS_DATA,
  UserDropdownSection,
} from '@highmark-web/highmark-common';
import { useIntl } from '@leagueplatform/locales';

export const useGetUserDropdownConfig = (props: UserDropdownProps) => {
  const { formatMessage } = useIntl();
  const currentScreen = useGetScreenForAnalytics();

  const coordinationOfBenefitsAnalyticsWithScreen = {
    ...NAV_ANALYTICS_DATA.SUBMENUS.USER_SETTINGS.COORDINATION_OF_BENEFITS,
    screen_name: currentScreen,
  };

  const userDropdownConfig: UserDropdownSection[] = [
    [
      {
        text: formatMessage({ id: 'ACCOUNT_MANAGEMENT' }),
        to: APP_MANAGED_ROUTES.ACCOUNT_MANAGEMENT,
        analytics: {
          ...NAV_ANALYTICS_DATA.SUBMENUS.USER_SETTINGS.ACCOUNT_MANAGEMENT,
          screen_name: currentScreen,
        },
      },
      // Conditionally add COB Link to list if insuranceAdministeredByThirdParty is true
      ...(props?.insuranceAdministeredByThirdParty
        ? [
            props.isCobSdkEnabled
              ? {
                  text: formatMessage({ id: 'COORDINATION_OF_BENEFITS' }),
                  to: APP_MANAGED_ROUTES.COORDINATION_OF_BENEFITS,
                  analytics: coordinationOfBenefitsAnalyticsWithScreen,
                }
              : {
                  text: formatMessage({ id: 'COORDINATION_OF_BENEFITS' }),
                  to: getAuthedWebviewUrl(AUTHED_WEBVIEW_URL_NAMES.COB_V2),
                  onClick() {
                    LinkHandler.handleLink(
                      getAuthedWebviewUrl(AUTHED_WEBVIEW_URL_NAMES.COB_V2),
                    );
                  },
                  analytics: coordinationOfBenefitsAnalyticsWithScreen,
                },
          ]
        : []),
      // Conditionally add Annual Authorizations link if feature flag is enabled
      ...(props?.isAnnualAuthorizationsEnabled
        ? [
            {
              text: formatMessage({ id: 'ANNUAL_AUTHORIZATIONS' }),
              to: APP_MANAGED_ROUTES.ANNUAL_AUTHORIZATIONS,
            },
          ]
        : []),
      // Conditionally add CoBrowse link to list if feature flag is enabled
      ...(props?.isCobrowseEnabled
        ? [
            {
              text: formatMessage({ id: 'START_COBROWSE' }),
              description: formatMessage({ id: 'START_COBROWSE_DESCRIPTION' }),
              to: '',
              onClick: () => {
                injectCobrowseInitiator();
              },
            },
          ]
        : []),
    ],
    [
      {
        text: formatMessage({ id: 'ABOUT_IEL' }),
        to: '/about',
      },
    ],
    [
      {
        to: '',
        text: formatMessage({ id: 'LOG_OUT' }),
        linkProps: {
          color: 'onSurface.text.critical',
        } as BoxProps,
        onClick: () => {
          props.onOpenSignoutModal();
        },
      },
    ],
  ];

  return userDropdownConfig;
};
